"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _routing = require("@engaging-tech/routing");
var _components = require("@engaging-tech/components");
var SectionHeader = (0, _styledComponents["default"])(_components.Text).withConfig({
  displayName: "FooterLinks__SectionHeader",
  componentId: "sc-1hg1bmm-0"
})(["&::first-letter{text-transform:uppercase;}"]);

/**
 * Renders an individual list of footer links.
 * @param {object} section The footer link section to render.
 * @package
 */
var LinkList = function LinkList(_ref) {
  var section = _ref.section,
    boldText = _ref.boldText;
  return /*#__PURE__*/_react["default"].createElement(_components.Box, {
    width: 1 / 1,
    mb: [3, 0]
  }, /*#__PURE__*/_react["default"].createElement(SectionHeader, {
    color: "dark.2",
    display: "block",
    mb: 3
  }, section.title), section.routes.map(function (route) {
    return /*#__PURE__*/_react["default"].createElement(_routing.Link, (0, _extends2["default"])({
      to: route.path,
      key: route.description
    }, route.linkProps), /*#__PURE__*/_react["default"].createElement(_components.Flex, {
      mb: [3, 3, 1]
    }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
      fontSize: [4, 4, 3],
      color: "primary.0",
      fontWeight: boldText ? 700 : 500
    }, route.description)));
  }));
};

/**
 * Renders a list of section links.
 * @param {array} sections A list of sections to render
 * as columns.
 * @package
 */
var FooterLinks = function FooterLinks(_ref2) {
  var sections = _ref2.sections,
    boldText = _ref2.boldText;
  return /*#__PURE__*/_react["default"].createElement(_components.Flex, {
    flexDirection: ["column", "row"],
    justifyContent: ["center", "space-between"],
    width: [1 / 1, 2 / 3, 1 / 2]
  }, sections.map(function (section) {
    return /*#__PURE__*/_react["default"].createElement(LinkList, {
      key: section.title,
      section: section,
      boldText: boldText
    });
  }));
};
var _default = exports["default"] = FooterLinks;